export enum CardBrand {
    VISA,
    MASTERCARD,
    AMERICAN_EXPRESS,
    MAESTRO,
    OTHER,
}